
import React, { useState } from "react"
import PropTypes from "prop-types"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { Button, Grid, Typography, Box, IconButton, Checkbox } from "@mui/material"
import { makeStyles } from "@mui/styles"
import { CircularProgress } from "@mui/material"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import CloseIcon from "@mui/icons-material/Close"

const useStyles = makeStyles(() => ({
    cancelButton: {
        fontSize: "16px !important",
        fontFamily: "Ubuntu !important",
        fontWeight: "500 !important",
        lineHeight: "24px !important",
        backgroundColor: "white !important",
        border: "2px solid #00BCD4 !important",
        borderRadius: "8px !important",
        color: "#00BCD4 !important",
        textTransform: "none !important",
        maxWidth: "125px !important",
        minWidth: "125px !important",
        maxHeight: "41px !important",
        minHeight: "41px !important",
        "&:hover": {
            backgroundColor: "#f5f5f5 !important",
        },
    },
    continueButton: {
        fontSize: "16px !important",
        fontFamily: "Ubuntu !important",
        fontWeight: "500 !important",
        lineHeight: "24px !important",
        backgroundColor: "#00BCD4 !important",
        color: "white !important",
        border: "none !important",
        borderRadius: "8px !important",
        textTransform: "none !important",
        maxWidth: "125px !important",
        minWidth: "125px !important",
        maxHeight: "41px !important",
        minHeight: "41px !important",
        "&:hover": {
            backgroundColor: "#00ACC1 !important",
        },
    },
    messageItem: {
        display: "flex !important",
        alignItems: "center !important",
        cursor: "pointer !important",
        "&:hover": {
            backgroundColor: "#f5f5f5 !important",
        },
    },
}))

const MessageOptionsModal = ({ open, setOpen, improvedMessages, setMessage, loadingImprovedMessages, trigger }) => {
    const classes = useStyles()
    const [selectedMessage, setSelectedMessage] = useState(null)

    const handleClose = () => {
        setSelectedMessage(null)
        setOpen(false)
    }

    const handleCheckboxChange = (message) => {
        setSelectedMessage(message === selectedMessage ? null : message)
    }

    const handleContinue = () => {
        if (selectedMessage) {
            setMessage("message", selectedMessage, { shouldDirty: true })
            trigger("message")
            setSelectedMessage(null)
            setOpen(false)
        }
    }

    return (
        <Dialog
            open={open}
            onClose={(_event, reason) => {
                if (reason !== 'backdropClick') {
                    handleClose()
                }
            }}
            disableEscapeKeyDown={false}
            sx={{
                "& .MuiDialog-paper": {
                    width: "530px",
                    margin: 0,
                    height: "558px",
                    scrollbarWidth: "none",
                    overflow: "hidden",
                    borderRadius: "8px",
                },
            }}
        >
            <DialogTitle sx={{ borderBottom: '1px solid #363636' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <IconButton onClick={handleClose} sx={{ color: '#363636' }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography
                        sx={{
                            color: 'var(--Color-7, #363636)',
                            fontFamily: 'Ubuntu',
                            fontSize: '24px',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            lineHeight: '40px',
                            letterSpacing: '0.15px',
                            flex: 1,
                            textAlign: 'center',
                        }}
                    >
                        Mensajes sugeridos
                    </Typography>
                    <IconButton onClick={handleClose} sx={{ color: '#363636' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography
                    sx={{
                        color: 'rgba(0, 0, 0, 0.87)',
                        fontFamily: 'Ubuntu',
                        fontSize: '13px',
                        fontWeight: 400,
                        lineHeight: '24px',
                        margin: '32px 0 64px 0 !important',
                        textAlign: 'center'
                    }}
                >
                    Selecciona uno de los siguientes mensajes para tu campaña:
                </Typography>
                <Grid container direction="column" spacing={'24px'}>
                    {loadingImprovedMessages ? (
                        <Grid item sx={{ display: 'flex', justifyContent: 'center', height: '220px', alignItems: 'center' }}>
                            <CircularProgress size={75}/>
                        </Grid>
                    ) : (
                        improvedMessages.map((message, index) => (
                            <Grid item key={index}>
                                <Box
                                    className={classes.messageItem}
                                    onClick={() => handleCheckboxChange(message)}
                                >
                                    <Checkbox
                                        checked={selectedMessage === message}
                                        onChange={() => handleCheckboxChange(message)}
                                        sx={{
                                            color: '#00BCD4',
                                            '&.Mui-checked': {
                                                color: '#00BCD4',
                                            },
                                            padding: '0 12px 0 0'
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            color: '#363636',
                                            fontFamily: 'Ubuntu',
                                            fontSize: '16px',
                                            fontWeight: 300,
                                            lineHeight: '24px',
                                        }}
                                    >
                                        {message}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))
                    )}
                </Grid>
            </DialogContent>
            <DialogActions sx={{ padding: '0px 75px 50px 75px', justifyContent: 'space-between'}}>
                <Button
                    className={classes.cancelButton}
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    className={classes.continueButton}
                    onClick={handleContinue}
                    disabled={!selectedMessage}
                >
                    Continuar
                </Button>
            </DialogActions>
        </Dialog>
        )
}

MessageOptionsModal.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    improvedMessages: PropTypes.array.isRequired,
    setMessage: PropTypes.func.isRequired,
    loadingImprovedMessages: PropTypes.bool.isRequired,
    trigger: PropTypes.func.isRequired,
}

export default MessageOptionsModal
